// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Toc-module--bx--text-truncate--end--wXfRU";
export var bxTextTruncateFront = "Toc-module--bx--text-truncate--front---X22L";
export var container = "Toc-module--container--GtPD6";
export var isCurrent = "Toc-module--isCurrent--Ysw+v";
export var toc = "Toc-module--toc--1uwql";
export var tocList = "Toc-module--tocList--TBS0f";